/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Resources_Newsletter_TitleInputs */

const en_directory_resources_newsletter_title = /** @type {(inputs: Directory_Resources_Newsletter_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get the weekly product brief`)
};

const zh_directory_resources_newsletter_title = /** @type {(inputs: Directory_Resources_Newsletter_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`获取每周产品简报`)
};

/**
* | output |
* | --- |
* | "Get the weekly product brief" |
*
* @param {Directory_Resources_Newsletter_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_resources_newsletter_title = /** @type {((inputs?: Directory_Resources_Newsletter_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Resources_Newsletter_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_resources_newsletter_title(inputs)
	return zh_directory_resources_newsletter_title(inputs)
});
export { directory_resources_newsletter_title as "directory.resources.newsletter.title" }